export default {"src":"/_next/static/media/arrowDown.82a23a4a.svg","height":10,"width":16};